<template>
  <fieldset class="tab tab-01">
    <div class="heading-form a-center">
      <span class="number">1/11</span>
      <p class="c-yellow">ข้อมูลส่วนตัว</p>
      <h2 class="heading-h2 c-white">ข้อมูลของคุณ</h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for class="icw-label overlabel">
              ชื่อ (ภาษาไทย)
              <span class="c-star">
                <sup>*</sup>
              </span>
            </label>
            <input
              id="txtFirstName"
              type="text"
              placeholder
              :class="{ 'input-required': !firstname.trim() && isError }"
              v-model="firstname"
              maxlength="50"
              @keypress="thOnly($event)"
            />
            <p class="input-note c-red" v-if="!firstname.trim() && isError">โปรดระบุ</p>
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for class="icw-label overlabel">
              นามสกุล (ภาษาไทย)
              <span class="c-star">
                <sup>*</sup>
              </span>
            </label>
            <input
              id="txtLastName"
              type="text"
              placeholder
              :class="{ 'input-required': !lastname.trim() && isError }"
              v-model="lastname"
              maxlength="50"
              @keypress="thOnly($event)"
            />
            <p class="input-note c-red" v-if="!lastname.trim() && isError">โปรดระบุ</p>
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input h-txtlast">
            <label for class="icw-label overlabel">
              อายุ
              <span class="c-star">
                <sup>*</sup>
              </span>
            </label>
            <InputPattern
              id="txtAge"
              type="text"
              placeholder
              :class="{ 'input-required': !age && isError }"
              @blur="checkAge()"
              v-model="age"
              maxlength="2"
              :regExp="/^[0\D]*|\D*/g"
              pattern="\d*"
            />
            <label for class="icw-label overlabel txt-last">ปี</label>
            <p class="input-note c-red" v-if="!age && isError">โปรดระบุ</p>
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox icon-none icw-input-gender" id="rdoGender">
            <label class="icw-label">
              เพศ
              <span class="c-star">
                <sup>*</sup>
              </span>
            </label>
            <div class="checkbox checkbox-inline">
              <input
                type="radio"
                name="radioInlineGender"
                id="radioInlineMale"
                class="css-checkbox"
                value="m"
                v-model="gender"
              />
              <label for="radioInlineMale" class="css-label">ชาย</label>
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="radio"
                name="radioInlineGender"
                id="radioInlineFeMale"
                class="css-checkbox"
                value="f"
                v-model="gender"
              />
              <label for="radioInlineFeMale" class="css-label">หญิง</label>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button v-if="envShowButtonAutoTest == 'development'"
        id="btnAutoKeyData"
        type="button"
        name="autodata"
        class="btn btn-test previous"
        style="background-color: #60e2fa"
        @click="autoKeyDataTest()"
      >Auto Test</button>
    </div>
    <button
      id="btnNextStepQ2"
      type="button"
      name="next"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >ถัดไป</button>
  </fieldset>
</template>

<script>

import Vue from "vue";

import InputPattern from "vue-pattern-input";

import { my_storage, incCurrentStep } from "@/helpers/global_helper.js";
import { nextStep } from "@/helpers/step_helper.js";

import MyConfig from "@/../me.config.js";

export default {
  name: "QuestionStep1_Q1",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  data() {
    return {
      firstname: my_storage(this.QuestionType, "firstname"),
      lastname: my_storage(this.QuestionType, "lastname"),
      age: my_storage(this.QuestionType, "age"),
      gender: my_storage(this.QuestionType, "gender"),
      envShowButtonAutoTest: typeof window._site_params !== "undefined" ? window._site_params.env : "development"
    };
  },
  methods: {
    my_storage,
    nextStep,
    beforeNextStep() {
      if (
        this.firstname.trim() != "" &&
        this.lastname.trim() != "" &&
        this.age != "" &&
        this.gender != ""
      ) {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));

        let currentTag = this.$vnode.componentOptions.tag;
        currentTag = currentTag.replace("Q", "");
        incCurrentStep("step1", currentTag);

        this.isError = false;
        this.nextStep("tab-01", "tab-02");
      } else {
        this.isError = true;
      }
    },
    checkAge() {
      if (this.age != "" && this.age < 20) {
        this.age = "20";
      }
    },
    thOnly(event) {
      const pattern_thai = /[ก-๏\s]+$/u;
      const digit = String.fromCharCode(event.which);
      if (pattern_thai.test(digit) && event.keyCode !== 32) {
        return event.target.value;
      } else {
        return event.preventDefault();
      }
    },
    autoKeyDataTest() {
      sessionStorage.setItem("step1", 11);
      sessionStorage.setItem("step2", 10);
      sessionStorage.setItem("step3", 17);

      sessionStorage.setItem("setup", JSON.stringify({
        auto: true
      }));

      // STEP 1 : 1
      sessionStorage.setItem("Information", JSON.stringify({
        firstname: "ทดสอบการใช่งาน",
        lastname: "ระบบขั้นแรก",
        age: "25",
        gender: "f"
      }));

      // STEP 1 : 2
      sessionStorage.setItem("Job", JSON.stringify({
        isError: false,
        job: "student",
        job_etc: "",
        wrongFormat: false
      }));

      // STEP 1 : 3
      sessionStorage.setItem("Contact", JSON.stringify({
        email: "",
        isConsentFlag: null,
        isEmailValid: true,
        isError: false,
        isPhoneValid: true,
        lineid: "",
        phone: "099-999-9999",
        wrongFormat: false
      }));

      // STEP 1 : 4
      sessionStorage.setItem("Profile", JSON.stringify({
        addr_building: "",
        addr_district: "",
        addr_moo: "",
        addr_no: "",
        addr_province: "",
        addr_soi: "",
        addr_subdistrict: "",
        addr_zipcode: "",
        _district_id: "",
        _province_id: ""
      }));

      // STEP 1 : 5
      sessionStorage.setItem("Income", JSON.stringify({
        isError: false,
        salary: "10,000",
        wrongFormat: false
      }));

      // STEP 1 : 6
      sessionStorage.setItem("LifeStyle", JSON.stringify({
        isError: false,
        lifestyles: ["music", "game"],
        lifestyles_etc: "",
        wrongFormat: false
      }));

      // STEP 1 : 7
      sessionStorage.setItem("Healthy", JSON.stringify({
        healthy: ["exercise"],
        isError: false,
        more_healthy: ["runing", "walk"],
        more_healthy_text: "",
        wrongFormat: false
      }));

      // STEP 1 : 8
      sessionStorage.setItem("LifestyleGadget", JSON.stringify({
        gadget: ["applewatch", "huawei"],
        gadget_etc: "",
        isError: false,
        wrongFormat: false
      }));

      // STEP 1 : 9
      sessionStorage.setItem("HealthyActivities", JSON.stringify({
        isError: false,
        workout_rate: "-1",
        wrongFormat: false
      }));

      // STEP 1 : 10
      sessionStorage.setItem("RunActivities", JSON.stringify({
        isError: false,
        run_rate: "-1",
        wrongFormat: false
      }));

      // STEP 1 : 11
      sessionStorage.setItem("BikeActivities", JSON.stringify({
        bike: "-1",
        isError: false,
        wrongFormat: false
      }));

      // STEP 2 : 1
      sessionStorage.setItem("ChildParent", JSON.stringify({
        child: "0",
        child_age: [0, 0, 0, 0, 0],
        disableSaveRetire: false,
        isError: false,
        is_legacy: false,
        is_save_retire: false,
        is_stanby: false,
        parent: "0",
        save_types: [],
        wrongFormat: false
      }));

      // STEP 2 : 2
      sessionStorage.setItem("Expenses", JSON.stringify({
        disableSaveRetire: false,
        expenses: "100",
        isError: false,
        is_legacy: false,
        is_save_retire: false,
        is_stanby: false,
        save_types: [],
        wrongFormat: false
      }));

      // STEP 2 : 3
      sessionStorage.setItem("MoneyHealth1", JSON.stringify({
        disableSaveRetire: false,
        isError: false,
        is_legacy: false,
        is_save_retire: false,
        is_stanby: true,
        money_health: "-1",
        need_money: "",
        save_types: [],
        wrongFormat: false
      }));

      // STEP 2 : 4
      sessionStorage.setItem("MoneyHealth2", JSON.stringify({
        disableSaveRetire: false,
        isError: false,
        is_legacy: false,
        is_save_retire: false,
        is_stanby: false,
        save_types: [],
        saving_type: "needsave",
        wrongFormat: false
      }));

      // STEP 2 : 5
      sessionStorage.setItem("MoneyHealth3", JSON.stringify({
        disableSaveRetire: false,
        isError: false,
        is_legacy: false,
        is_save_retire: false,
        is_stanby: false,
        save_format: ["fund", "savebank"],
        save_format_etc: "",
        save_types: [],
        wrongFormat: false
      }));

      // STEP 2 : 6
      sessionStorage.setItem("MoneyHealth4", JSON.stringify({
        disableSaveRetire: false,
        isError: false,
        is_legacy: false,
        is_save_retire: false,
        is_stanby: false,
        save_types: [],
        vat_refund: "notsure",
        wrongFormat: false
      }));

      // STEP 2 : 7
      sessionStorage.setItem("MoneyHealth5", JSON.stringify({
        disableSaveRetire: false,
        isError: false,
        is_legacy: false,
        is_save_retire: false,
        is_stanby: false,
        retire: "98",
        save_types: [],
        wrongFormat: false,
      }));

      // STEP 2 : 8
      sessionStorage.setItem("MoneyHealth6", JSON.stringify({
        disableSaveRetire: false,
        isError: false,
        is_legacy: false,
        is_save_retire: true,
        is_stanby: false,
        money_retire: "-1",
        need_money_retire: "",
        save_types: [],
        wrongFormat: false
      }));

      // STEP 2 : 9
      sessionStorage.setItem("MoneyHealth7", JSON.stringify({
        disableSaveRetire: false,
        isError: false,
        is_legacy: true,
        is_save_retire: false,
        is_stanby: false,
        money_to_child: "-1",
        need_money_to_child: "",
        save_types: [],
        wrongFormat: false
      }));

      // STEP 2 : 10
      sessionStorage.setItem("MoneyHealth8", JSON.stringify(["inc_saving", "changevat"]));
      sessionStorage.setItem("HealthInfo", JSON.stringify({
        heartrate: "-1",
        heartrate_num: "",
        height: "172",
        isError: false,
        pressure: "-1",
        pressure_down: "",
        pressure_up: "",
        weight: "70",
        wrongFormat: false
      }));

      // STEP 3 : 1
      sessionStorage.setItem("RelaxTime", JSON.stringify({
        isError: false,
        sleep_time: "more8hour",
        wrongFormat: false
      }));

      // STEP 3 : 2
      sessionStorage.setItem("WorkoutRate", JSON.stringify({
        isError: false,
        wakeup_freq: "-1",
        wrongFormat: false
      }));

      // STEP 3 : 3
      sessionStorage.setItem("WorkoutTime", JSON.stringify({
        isError: false,
        wakeup_freq: "-1",
        wrongFormat: false
      }));

      // STEP 3 : 4
      sessionStorage.setItem("WakeupFreq", JSON.stringify({
        isError: false,
        wakeup_freq: "-1",
        wrongFormat: false
      }));

      // STEP 3 : 5
      sessionStorage.setItem("RideFreq", JSON.stringify({
        isError: false,
        ride_freq: "everyday",
        wrongFormat: false
      }));

      // STEP 3 : 6
      sessionStorage.setItem("HangoutFreq", JSON.stringify({
        hangout: "everyday",
        isError: false,
        wrongFormat: false
      }));

      // STEP 3 : 7
      sessionStorage.setItem("UseMobilePhone", JSON.stringify({
        isError: false,
        use_mobilephone: "everyday",
        wrongFormat: false
      }));

      // STEP 3 : 8
      sessionStorage.setItem("Cigarrete", JSON.stringify({
        cigarette: "-1",
        isError: false,
        wrongFormat: false
      }));

      // STEP 3 : 9
      sessionStorage.setItem("Cancer", JSON.stringify({
        cancer: "-1",
        isError: false,
        wrongFormat: false
      }));

      // STEP 3 : 10
      sessionStorage.setItem("EatHotdog", JSON.stringify({
        eathotdog: "everyday",
        isError: false,
        wrongFormat: false
      }));

      // STEP 3 : 11
      sessionStorage.setItem("MilkTea", JSON.stringify({
        milktea: "everyday",
        isError: false,
        wrongFormat: false
      }));

      // STEP 3 : 12
      sessionStorage.setItem("Fried", JSON.stringify({
        fried: "everyday",
        isError: false,
        wrongFormat: false
      }));

      // STEP 3 : 13
      sessionStorage.setItem("Noodle", JSON.stringify({
        noodle: "everyday",
        isError: false,
        wrongFormat: false
      }));

      // STEP 3 : 14
      sessionStorage.setItem("Bored", JSON.stringify({
        bored: "-1",
        isError: false,
        wrongFormat: false
      }));

      // STEP 3 : 15
      sessionStorage.setItem("Dismal", JSON.stringify({
        dismal: "-1",
        isError: false,
        wrongFormat: false
      }));

      // STEP 3 : 16
      sessionStorage.setItem("NotFocus", JSON.stringify({
        notfocus: "-1",
        isError: false,
        wrongFormat: false
      }));

      window.location.href = MyConfig.HealthPath;
    }
  },
  computed: {
    isPass() {
      return (
        this.firstname.trim() != "" &&
        this.lastname.trim() != "" &&
        this.age.trim() != "" &&
        this.gender.trim() != ""
      );
    }
  }
};
</script>
